import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserManagementComponent } from './user-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserManagementService } from './user-management.service';
import { SharedModule } from '../shared/shared.module';
import { AddUserComponent } from './add-user.component';
import { HelpUserComponent } from './user-help.component';
import { UserService } from './user.service';
import { UserMenuComponent } from './user-menu.component';
@NgModule({
    declarations: [
        UserManagementComponent,
        AddUserComponent,
        HelpUserComponent,
        UserMenuComponent
    ],
    imports: [
        ReactiveFormsModule,
        SharedModule,
        FormsModule
    ],
    providers: [UserManagementService, UserService]
})

export class UserManagementModule {

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user-management.module.ts